import React, { useEffect } from 'react'
import { createPortal } from 'react-dom'

export default function ConsoleDialog({
    show,
    onClose,
    title,
    description,
    icon = 'fa-cube',
    tone = 'default',
    children,
    footer,
    className = '',
    bodyClassName = '',
    closeLabel = 'Close',
}) {
    useEffect(() => {
        if (!show) return undefined
        const previousOverflow = document.body.style.overflow
        const closeOnEscape = (event) => {
            if (event.key === 'Escape') onClose?.()
        }
        document.body.style.overflow = 'hidden'
        document.addEventListener('keydown', closeOnEscape)
        return () => {
            document.body.style.overflow = previousOverflow
            document.removeEventListener('keydown', closeOnEscape)
        }
    }, [onClose, show])

    if (!show || typeof document === 'undefined') return null

    return createPortal(
        <div className="console-dialog-layer" role="presentation" onMouseDown={(event) => {
            if (event.target === event.currentTarget) onClose?.()
        }}>
            <section className={`console-dialog is-${tone} ${className}`} role="dialog" aria-modal="true" aria-label={typeof title === 'string' ? title : undefined}>
                <header className="console-dialog__header">
                    <span className="console-dialog__icon"><i className={`fa ${icon}`} /></span>
                    <div>
                        <h2>{title}</h2>
                        {description && <p>{description}</p>}
                    </div>
                    <button type="button" className="console-dialog__close" onClick={onClose} aria-label={closeLabel} title={closeLabel}>
                        <i className="fa fa-times" />
                    </button>
                </header>
                <div className={`console-dialog__body ${bodyClassName}`.trim()}>{children}</div>
                {footer && <footer className="console-dialog__footer">{footer}</footer>}
            </section>
        </div>,
        document.body
    )
}
